import { LoginCognitoModel, LoginModel } from "../../features/authentication/model";

export const LoginUserApi = async (user: LoginCognitoModel) => {
    return user;
}

export const logout = async (user: LoginModel) => {
    const { userId, password } = user;
    return user;
}